import React from "react";
import { Link } from "react-router-dom";

export const ProductLinkRenderer = ({ value, data }) => {
    if (!data) return null;
    return <Link to={`/product/${data.id}`}>{value}</Link>;
};
